const TurkeySvg = () => (
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_4152_112596)">
      <path
        d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z"
        fill="#D80027"
      />
      <path
        d="M19.1809 16.3428L20.8219 18.6041L23.4795 17.7424L21.8359 20.0018L23.4766 22.263L20.82 21.398L19.1765 23.6574L19.1782 20.8636L16.5215 19.9986L19.1791 19.1368L19.1809 16.3428Z"
        fill="#F0F0F0"
      />
      <path
        d="M14.7031 25.6517C11.5816 25.6517 9.05096 23.1211 9.05096 19.9995C9.05096 16.878 11.5816 14.3473 14.7031 14.3473C15.6764 14.3473 16.5922 14.5935 17.3917 15.0267C16.1374 13.8 14.4221 13.043 12.5292 13.043C8.68721 13.043 5.57275 16.1575 5.57275 19.9995C5.57275 23.8414 8.68729 26.9559 12.5292 26.9559C14.4222 26.9559 16.1375 26.1988 17.3917 24.9722C16.5922 25.4055 15.6764 25.6517 14.7031 25.6517Z"
        fill="#F0F0F0"
      />
    </g>
    <defs>
      <clipPath id="clip0_4152_112596">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default TurkeySvg;
